export default __webpack_public_path__ + "038f97f17e3707f9d5cb46898e39f325.woff2";